import React from 'react';
import { Input } from 'reactstrap';
import { mergeClassNames } from '../../../../shared/utility';

export function SelectInput({
    elementConfig,
    analyticsClassName,
    value,
    sharedLabelAttr,
    changed,
    disabled,
    required,
}) {
    return (
        <Input
            type="select"
            autoComplete={elementConfig.autoComplete}
            className={mergeClassNames(elementConfig?.className, analyticsClassName)}
            value={value}
            {...sharedLabelAttr}
            onChange={changed}
            disabled={disabled}
            required={required}
            aria-required={required}
        >
            {elementConfig.options.map((option) => (
                <option key={option.value} value={option.value} disabled={option.disabled} selected={option.selected}>
                    {option.displayValue}
                </option>
            ))}
        </Input>
    );
}
